import { languageMap } from "screens/patientInfo/helpers/language";
import { constants } from "../constants/redux-constants";
import { AVAILABLE_LANGUAGES } from "config/helpers/multilingual_helper";
import { cdssCustomTitleValidator } from "config/helpers/common_helper";

const initialState = {
  token: null,
  soapNoteGenerated: false,
  recording: false,
  paused: false,
  isEnding: false,
  language: AVAILABLE_LANGUAGES?.[0],
  hasErrorEncountered: false,
  conversationId: null,
  lastSyncedTimeStamp: null,
  cdss: null,
  cdssTabProps: {
    isSet: false,
    title: null,
    color: null
  },
  loading: {
    recording: false,
    paused: false,
  },
  progressState: {
    isProgressReady: false,
    progress: null,
    progressMessage: null,
    step: null,
    totalSteps: null
  },
  autoStart: false,
  isRecordingInProgress: false,
  endLoading: false,
};

const recognizerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RECOGNIZER.SET_SOAP_GENERATED:
      return { ...state, soapNoteGenerated: !!action.payload };

    case constants.RECOGNIZER.SET_SOAP_CONTENT:
      return { ...state, soapNoteContent: action.payload ?? null };
        
    case constants?.RECOGNIZER?.LANGUAGE:
      return {
        ...state,
        language: action?.payload,
      };
    case constants?.RECOGNIZER?.SET_STT_TOKEN:
      return {
        ...state,
        token: action?.payload,
        hasErrorEncountered: false,
        isEnding: false,
      };

    case constants.RECOGNIZER.START_RECORDING:
      return {
        ...state,
        recording: true,
        paused: false,
        hasErrorEncountered: false,
        conversationId: action.payload.conversationId,
        soapNoteGenerated: false,
        soapNoteContent: null,
      };
    case constants.RECOGNIZER.START_RECORDING_LOADING:
      return {
        ...state,
        loading: {
          ...state?.loading,
          recording: action.payload,
        },
      };

    case constants.RECOGNIZER.PAUSE_RECORDING:
      return {
        ...state,
        paused: true,
        recording: false,
      };

    case constants.RECOGNIZER.RESUME_RECORDING:
      return {
        ...state,
        recording: true,
        paused: false,
      };

    case constants.RECOGNIZER.STOP_RECORDING:
      return {
        ...state,
        recording: false,
        paused: false,
        conversationId: null,
        token: null,
        isEnding: false,
      };
    case constants.RECOGNIZER.HAS_ERROR_ENCOUNTERED:
      return {
        ...state,
        hasErrorEncountered: action?.payload,
        paused: false,
        recording: true,
      };
    case constants.RECOGNIZER.CONVERSATION_ENDING:
      return {
        ...state,
        isEnding: true,
      };
    case constants.RECOGNIZER.UPDATE_CDSS_DATA:
      if (action.payload?.lastComputedAt !== state.lastSyncedTimeStamp) {
        return {
          ...state,
          lastSyncedTimeStamp: action.payload?.lastComputedAt,
          cdss: action.payload?.result || {},
        };
      }
      return state;
    case constants.RECOGNIZER.RESET_RECOGNIZER:
      return {
        soapNoteGenerated: false,
        soapNoteContent: null,
        token: null,
        recording: false,
        paused: false,
        isEnding: false,
        language: AVAILABLE_LANGUAGES?.[0],
        hasErrorEncountered: false,
        conversationId: null,
        lastSyncedTimeStamp: null,
        cdss: null,
        loading: {
          recording: false,
          paused: false,
        },
        progressState: {
          isProgressReady: false,
          progress: null,
          progressMessage: null,
          step: null,
          totalSteps: null
        },
        autoStart: false,
      };
    case constants.RECOGNIZER.AUTO_START:
      return {
        ...state,
        autoStart: action.payload,
      };
    case constants.RECOGNIZER.START_RECORDING_IN_PROGRESS:
      return {
        ...state,
        isRecordingInProgress: action.payload,
      };
    case constants.RECOGNIZER.SET_END_LOADING:
      return {
        ...state,
        endLoading: action.payload,
      };
    case constants.RECOGNIZER.SET_CDSS_TITLE:
      const { color, isValid } = cdssCustomTitleValidator(action.payload);
      return {
        ...state,
        cdssTabProps: {
          isSet: isValid,
          title: isValid ? action.payload : null,
          color: isValid ? color : null,
        },
      };
    case constants.RECOGNIZER.UNSET_CDSS_TITLE:
      return {
        ...state,
        cdssTabProps: {
          isSet: false,
          title: null,
          color: null
        },
      };
    case constants.RECOGNIZER.UPDATE_PROGRESS_STATE:
      return {
        ...state,
        progressState: {
          ...action.payload
        }
      };
    case constants.RECOGNIZER.RESET_PROGRESS_STATE:
      return {
        ...state,
        progressState: {
          isProgressReady: false,
          progress: null,
          progressMessage: null,
          step: null,
          totalSteps: null
        }
      };

    default:
      return {
        ...state,
      };
  }
};

export default recognizerReducer;
